/* eslint-disable */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Paper,
    Typography,
    Box,
    Fade,
    Chip,
    Tabs,
    Tab,
    IconButton,
    Tooltip,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,        
    InputAdornment,     
    FormControl,         
    InputLabel,         
    Select,             
    MenuItem as SelectMenuItem  
} from '@mui/material';
import {
    Code,
    Add,
    NavigateNext,
    NavigateBefore,
    List as ListIcon,
    Edit as EditIcon,
    Delete as DeleteIcon,
    Block as BlockIcon,
    CheckCircle as ActivateIcon,
    Search as SearchIcon,   
    Clear as ClearIcon  
} from '@mui/icons-material';
import { useProjectCode } from 'hooks/api/terminology/project-code/useProjectCode';
import { useBranchCode } from 'hooks/api/terminology/branch-code/useBranchCode';
import { PaginationButton, StyledTableContainer, globalColor } from '../../ConstantColors';
import { logger } from 'utils/environment/log';
import Swal from 'sweetalert2';
import AddEditProjectCode from './add';
import {
    BudgetCell,
    ClampedText,
    CodeText,
    ConfigurationActionMenu,
    ConfigurationPagination,
    ConfigurationStatusChip,
    formatConfigurationDate,
    stickyActionCellSx,
    stickyActionHeadSx,
    tableSx
} from '../components/ConfigurationTable';

const SearchSection = ({ searchTerm, setSearchTerm, searchField, setSearchField, onClearSearch, loading }) => {
    const searchFields = [
        { value: 'name', label: 'Project Name' },
        { value: 'code', label: 'Project Code' },
        { value: 'branchCode.name', label: 'Branch Code' },
        { value: 'description', label: 'Description' },
        { value: 'createdBy', label: 'Created By' },
        { value: 'lastModifiedBy', label: 'Modified By' }
    ];

    return (
        <Box sx={{ mb: 3, display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
            <FormControl size="small" sx={{ minWidth: 150 }}>
                <InputLabel>Search Field</InputLabel>
                <Select value={searchField} label="Search Field" onChange={(e) => setSearchField(e.target.value)} disabled={loading}>
                    {searchFields.map((field) => (
                        <SelectMenuItem key={field.value} value={field.value}>
                            {field.label}
                        </SelectMenuItem>
                    ))}
                </Select>
            </FormControl>

            <TextField
                size="small"
                placeholder={`Search by ${searchFields.find((f) => f.value === searchField)?.label || 'Project Name'}...`}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                disabled={loading}
                sx={{ flexGrow: 1, maxWidth: 400 }}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon color="action" />
                        </InputAdornment>
                    ),
                    endAdornment: searchTerm && (
                        <InputAdornment position="end">
                            <IconButton size="small" onClick={onClearSearch} disabled={loading}>
                                <ClearIcon />
                            </IconButton>
                        </InputAdornment>
                    )
                }}
            />
        </Box>
    );
};

const ProjectCodeList = () => {
    const [activeTab, setActiveTab] = useState(0);
    
    // States for pagination and data
    const [page, setPage] = useState(0);
    const [rowsPerPage] = useState(5);

    // Search states
    const [searchTerm, setSearchTerm] = useState('');
    const [searchField, setSearchField] = useState('name');

    // Hooks
    const { listProjectCodes, updateProjectCode, deleteProjectCode, projectCodes } = useProjectCode();
    const { listBranchCodes, branchCodes } = useBranchCode();

    // Additional states
    const [editingProjectCode, setEditingProjectCode] = useState(null);
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const [projectCodeToDelete, setProjectCodeToDelete] = useState(null);
    const [toggleConfirmOpen, setToggleConfirmOpen] = useState(false);
    const [projectCodeToToggle, setProjectCodeToToggle] = useState(null);
    const [loading, setLoading] = useState(true);

    // Initial data fetch
    useEffect(() => {
        fetchInitialData();
    }, []);

    const fetchInitialData = async () => {
        setLoading(true);
        try {
            await Promise.all([listProjectCodes(0, 100), listBranchCodes(0, 100)]);
        } catch (error) {
            logger.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    // Helper function to get nested object value
    const getNestedValue = (obj, path) => {
        return path.split('.').reduce((current, key) => {
            return current && current[key] !== undefined ? current[key] : null;
        }, obj);
    };

    // Filter project codes based on search
    const getFilteredProjectCodes = () => {
        if (!searchTerm.trim()) {
            return projectCodes;
        }

        const searchLower = searchTerm.toLowerCase().trim();
        return projectCodes.filter((projectCode) => {
            const fieldValue = getNestedValue(projectCode, searchField);
            if (fieldValue === null || fieldValue === undefined) {
                return false;
            }
            return String(fieldValue).toLowerCase().includes(searchLower);
        });
    };

    const filteredProjectCodes = getFilteredProjectCodes();

    const handleClearSearch = () => {
        setSearchTerm('');
        setPage(0);
    };

    const handleEditClick = (projectCode) => {
        setEditingProjectCode(projectCode);
        setActiveTab(1);
    };

    const handleAddNew = () => {
        setEditingProjectCode(null);
        setActiveTab(1);
    };

    const handleDeleteClick = (projectCode) => {
        setProjectCodeToDelete(projectCode);
        setDeleteConfirmOpen(true);
    };

    const handleDeleteConfirm = async () => {
        try {
            await deleteProjectCode(projectCodeToDelete.id);
            await fetchInitialData();
            setDeleteConfirmOpen(false);
            setProjectCodeToDelete(null);
            Swal.fire({
                icon: 'success',
                title: 'Project Code Deleted',
                text: 'The project code has been successfully deleted.',
                showConfirmButton: false,
                timer: 1500
            });
        } catch (error) {
            logger.error('Error deleting project code:', error);
            
            let errorMessage = 'Failed to delete the project code. Please try again.';
            if (error.response && error.response.data && error.response.data.message) {
                errorMessage = error.response.data.message;
            } else if (error.response && error.response.status === 409) {
                errorMessage = 'Cannot delete project code. It may be in use by other records.';
            }

            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: errorMessage
            });
        }
    };

    const handleDeleteCancel = () => {
        setDeleteConfirmOpen(false);
        setProjectCodeToDelete(null);
    };

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
        if (newValue === 0) {
            setEditingProjectCode(null);
        }
    };

    const handleToggleActive = async (projectCode) => {
        setProjectCodeToToggle(projectCode);
        setToggleConfirmOpen(true);
    };

    const handleToggleConfirm = async () => {
        try {
            const updatedProjectCode = { ...projectCodeToToggle, isActive: !projectCodeToToggle.isActive };
            await updateProjectCode(projectCodeToToggle.id, updatedProjectCode);
            await fetchInitialData();
            setToggleConfirmOpen(false);
            setProjectCodeToToggle(null);
            Swal.fire({
                icon: 'success',
                title: projectCodeToToggle.isActive ? 'Project Code Deactivated' : 'Project Code Activated',
                text: `The project code has been successfully ${projectCodeToToggle.isActive ? 'deactivated' : 'activated'}.`,
                showConfirmButton: false,
                timer: 1500
            });
        } catch (error) {
            logger.error('Error toggling project code status:', error);
            
            let errorMessage = 'Failed to update project code status. Please try again.';
            if (error.response && error.response.data && error.response.data.message) {
                errorMessage = error.response.data.message;
            }

            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: errorMessage
            });
        }
    };

    const handleToggleCancel = () => {
        setToggleConfirmOpen(false);
        setProjectCodeToToggle(null);
    };

    const handleProjectCodeSubmitted = () => {
        fetchInitialData();
        setActiveTab(0);
        setEditingProjectCode(null);
    };

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2
        }).format(amount || 0);
    };

    const renderProjectCodesList = () => (
        <Box sx={{ mt: 4 }}>
            <SearchSection
                searchTerm={searchTerm}
                setSearchTerm={(value) => {
                    setSearchTerm(value);
                    setPage(0);
                }}
                searchField={searchField}
                setSearchField={setSearchField}
                onClearSearch={handleClearSearch}
                loading={loading}
            />

            <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="body2" color="text.secondary">
                    {searchTerm ? (
                        <>
                            Showing {filteredProjectCodes.length} of {projectCodes.length} project codes
                            {filteredProjectCodes.length > 0 && ` matching "${searchTerm}"`}
                        </>
                    ) : (
                        <>Total: {projectCodes.length} project codes</>
                    )}
                </Typography>
                <Button
                    variant="contained"
                    startIcon={<Add />}
                    onClick={handleAddNew}
                    sx={{
                        backgroundColor: globalColor,
                        '&:hover': {
                            backgroundColor: globalColor,
                            opacity: 0.9
                        }
                    }}
                >
                    Add New Project Code
                </Button>
            </Box>

            <Fade in timeout={1000}>
                <StyledTableContainer component={Paper}>
                    <Table size="small" sx={tableSx(900)}>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ width: 72 }}>ID</TableCell>
                                <TableCell>Name</TableCell>
                                <TableCell sx={{ width: 112 }}>Code</TableCell>
                                <TableCell sx={{ width: 130 }}>Branch</TableCell>
                                <TableCell sx={{ width: 132 }}>Budget</TableCell>
                                <TableCell sx={{ width: 118 }}>Created</TableCell>
                                <TableCell sx={{ width: 92 }}>Status</TableCell>
                                <TableCell align="center" sx={stickyActionHeadSx}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredProjectCodes.length > 0 ? (
                                filteredProjectCodes.slice(page * rowsPerPage, (page + 1) * rowsPerPage).map((projectCode) => (
                                    <TableRow key={projectCode.id}>
                                        <TableCell><CodeText>{projectCode.id}</CodeText></TableCell>
                                        <TableCell><ClampedText>{projectCode.name}</ClampedText></TableCell>
                                        <TableCell><CodeText>{projectCode.code}</CodeText></TableCell>
                                        <TableCell><ClampedText maxWidth={130}>{projectCode.branchCode?.name}</ClampedText></TableCell>
                                        <TableCell>
                                            <BudgetCell
                                                primary={projectCode.totalBudget}
                                                secondary={projectCode.remainingBudget}
                                                formatCurrency={formatCurrency}
                                            />
                                        </TableCell>
                                        <TableCell sx={{ whiteSpace: 'nowrap' }}>{formatConfigurationDate(projectCode.createdAt)}</TableCell>
                                        <TableCell>
                                            <ConfigurationStatusChip active={projectCode.isActive} />
                                        </TableCell>
                                        <TableCell align="center" sx={stickyActionCellSx}>
                                            <ConfigurationActionMenu
                                                label={projectCode.name}
                                                actions={[
                                                    { label: 'Edit', icon: EditIcon, onClick: () => handleEditClick(projectCode) },
                                                    {
                                                        label: projectCode.isActive ? 'Deactivate' : 'Activate',
                                                        icon: projectCode.isActive ? BlockIcon : ActivateIcon,
                                                        color: projectCode.isActive ? '#b54708' : '#25643b',
                                                        onClick: () => handleToggleActive(projectCode)
                                                    }
                                                ]}
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={8} align="center">
                                        <Box sx={{ py: 4 }}>
                                            <Typography variant="body1" color="text.secondary">
                                                {searchTerm ? (
                                                    <>
                                                        No project codes found matching "{searchTerm}" in {searchField}
                                                        <Box sx={{ mt: 2 }}>
                                                            <Typography
                                                                variant="body2"
                                                                color="primary"
                                                                sx={{ cursor: 'pointer', textDecoration: 'underline' }}
                                                                onClick={handleClearSearch}
                                                            >
                                                                Clear search to view all project codes
                                                            </Typography>
                                                        </Box>
                                                    </>
                                                ) : (
                                                    'No project codes available'
                                                )}
                                            </Typography>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>

                    <ConfigurationPagination
                        page={page}
                        rowsPerPage={rowsPerPage}
                        total={filteredProjectCodes.length}
                        onPageChange={setPage}
                    />
                </StyledTableContainer>
            </Fade>
        </Box>
    );

    const renderToggleDialog = () => (
        <Dialog open={toggleConfirmOpen} onClose={handleToggleCancel}>
            <DialogTitle>
                {projectCodeToToggle?.isActive ? 'Deactivate Project Code' : 'Activate Project Code'}
            </DialogTitle>
            <DialogContent>
                <Typography>
                    Are you sure you want to {projectCodeToToggle?.isActive ? 'deactivate' : 'activate'} the project code "{projectCodeToToggle?.name}"?
                    {projectCodeToToggle?.isActive && ' This will make the project code unavailable for use.'}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleToggleCancel}>Cancel</Button>
                <Button 
                    onClick={handleToggleConfirm} 
                    color={projectCodeToToggle?.isActive ? 'warning' : 'success'} 
                    variant="contained"
                >
                    {projectCodeToToggle?.isActive ? 'Deactivate' : 'Activate'}
                </Button>
            </DialogActions>
        </Dialog>
    );

    const renderDeleteDialog = () => (
        <Dialog open={deleteConfirmOpen} onClose={handleDeleteCancel}>
            <DialogTitle>Confirm Project Code Deletion</DialogTitle>
            <DialogContent>
                <Typography>Are you sure you want to delete the project code "{projectCodeToDelete?.name}"? This action cannot be undone.</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleDeleteCancel}>Cancel</Button>
                <Button onClick={handleDeleteConfirm} color="error" variant="contained">
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );

    return (
        <Box sx={{ p: 3 }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
                <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    sx={{
                        '& .MuiTab-root': {
                            fontSize: '1rem',
                            textTransform: 'none'
                        }
                    }}
                >
                    <Tab icon={<ListIcon />} iconPosition="start" label="Project Codes List" />
                    <Tab icon={<Add />} iconPosition="start" label={editingProjectCode ? 'Edit Project Code' : 'Add New Project Code'} />
                </Tabs>
            </Box>

            {activeTab === 0 ? (
                renderProjectCodesList()
            ) : (
                <AddEditProjectCode
                    editingProjectCode={editingProjectCode}
                    onProjectCodeSubmitted={handleProjectCodeSubmitted}
                    branchCodes={branchCodes}
                />
            )}
            
            {renderToggleDialog()}
            {renderDeleteDialog()}
        </Box>
    );
};

export default ProjectCodeList;
